import store from "@frameworks/web/redux/store";
import { CLIENT_VAL_OTP, CLIENT_VAL_OTP_ERROR, CLIENT_VAL_OTP_HIDE_ERROR, CLIENT_VAL_OTP_START_LOADER, CLIENT_VAL_OTP_STOP_LOADER, LOGIN_SHOW_POPUP, } from "../interface/IClientValOTP";
class ClientValOTPActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    setShowLoginPopup(loginPopup) {
        this.dispatch({
            type: LOGIN_SHOW_POPUP,
            payload: { showLoginPopup: loginPopup },
        });
    }
    clientValidateOTP(data) {
        this.dispatch({
            type: CLIENT_VAL_OTP,
            payload: { data },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: CLIENT_VAL_OTP_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: CLIENT_VAL_OTP_HIDE_ERROR,
        });
    }
    loader() {
        this.dispatch({
            type: CLIENT_VAL_OTP_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: CLIENT_VAL_OTP_STOP_LOADER,
        });
    }
}
export default ClientValOTPActions;
